import { ApiReceivingLogRow } from "./ApiReceivingLogRow";
export class ApiLogFilterParams {
    _ALL?: string;
    vendor?: string;
    jobNumber?: string;
    jobName?: string;
    jcDept?: string;
    poNumber?: string;
    items?: string;
    email?: string;
    quantity?: string;
    location?: string;
    dateIn?: string | null;
    dateOut?: string | null;
    takenBy?: string;
    shopFloorSF?: number;
    shipmentType?: string;
    loggedBy?: string;
    checkedOut?: boolean;
    notes?: string;
    storageFacility?: string;
  
    public constructor(init?: Partial<ApiReceivingLogRow>) {
        if (init) {
          this.vendor = init.vendor;
          this.jobNumber = init.jobNumber;
          this.jobName = init.jobName;
          this.jcDept = init.jcDept;
          this.poNumber = init.poNumber;
          this.items = init.items;
          this.email = init.email;
          this.quantity = init.quantity;
          this.location = init.location;
          this.dateIn = init.dateIn;
          this.dateOut = init.dateOut;
          this.takenBy = init.takenBy;
          this.shopFloorSF = init.shopFloorSF;
          this.shipmentType = init.shipmentType;    
          this.loggedBy = init.loggedBy;
          this.checkedOut = init.checkedOut;
          this.notes = init.notes;
          this.storageFacility = init.storageFacility;
        }
    }
  
}